import { render, staticRenderFns } from "./ApprovalMaterialityRu.vue?vue&type=template&id=03557512&scoped=true"
import script from "./ApprovalMaterialityRu.vue?vue&type=script&lang=js"
export * from "./ApprovalMaterialityRu.vue?vue&type=script&lang=js"
import style0 from "./ApprovalMaterialityRu.vue?vue&type=style&index=0&id=03557512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03557512",
  null
  
)

export default component.exports